import urlConfigs from '../hooks/urlConfigs';
import { httpClient } from './http';
import { cacheGet } from '../util/cache';
import configs from '../config/app';

export class obeliskClient extends httpClient {
  constructor() {
    super();
    this.baseUrl = configs.obeliskApi;
    this.version = configs.obeliskVersion;
    this.init();
    this.headers = {};
    this.simulated = false;
    this.setHeader('Content-Type', 'application/json');
    this.setHeader('Accept', 'application/json');
    // Get fresh token each time instance is created
    const apiToken = cacheGet('apiToken', true, { jwtToken: '' });
    this.setHeader('Authorization', `Bearer ${apiToken?.jwtToken || ''}`);
  }
  /**
   * Set the API version for the client.
   * @param {number} version - The API version to set.
   * @returns {obeliskClient} - The current client instance.
   */
  setVersion(version) {
    this.version = version;
    return this;
  }

  async post(
    service,
    body = {},
    callBack = undefined,
    transformer = undefined,
    headers = {}
  ) {
    return await this.transmit(
      this.getCallByType(service),
      body,
      'POST',
      headers,
      transformer,
      callBack
    );
  }

  async get(
    service,
    body = {},
    callBack = undefined,
    transformer = undefined,
    headers = {}
  ) {
    return await this.transmit(
      this.getCallByType(service),
      body,
      'GET',
      headers,
      transformer,
      callBack
    );
  }

  async put(
    service,
    body = {},
    callBack = undefined,
    transformer = undefined,
    headers = {}
  ) {
    return await this.transmit(
      this.getCallByType(service),
      body,
      'PUT',
      headers,
      transformer,
      callBack
    );
  }

  async patch(
    service,
    body = {},
    callBack = undefined,
    transformer = undefined,
    headers = {}
  ) {
    return await this.transmit(
      this.getCallByType(service),
      body,
      'PATCH',
      headers,
      transformer,
      callBack
    );
  }

  async delete(
    service,
    body = {},
    callBack = undefined,
    transformer = undefined,
    headers = {}
  ) {
    return await this.transmit(
      this.getCallByType(service),
      body,
      'DELETE',
      headers,
      transformer,
      callBack
    );
  }
  /**
   * @param {Record<string, any>} [headers={}]
   * @returns {Record<string, string>}
   */
  assembleHeaders(headers = {}) {
    const ApiData = cacheGet('apiToken');
    headers = { ...headers, Authorization: `Bearer ${ApiData?.jwtToken || ''}` };
    return headers;
  }
  /**
   * @param {string} keyName
   * @returns {string}
   */
  getCallByType(keyName) {
    const path = urlConfigs[keyName] ?? null;
    if (path) return `${this.baseUrl}${path}`;
    return `${this.baseUrl}api/v${this.version}/${keyName}`;
  }
}
const obelisk = () => new obeliskClient();
export default obelisk;
